import { MessageCircle } from "lucide-react";
import React, { useState } from "react";

export default function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");

  const toggleChat = () => setOpen(!open);

  const sendMessage = () => {
    if (!input.trim()) return;

    // Add user message
    const newMessages = [...messages, { text: input, sender: "user" }];

    // Fake bot reply
    newMessages.push({ text: `You said: ${input}`, sender: "bot" });

    setMessages(newMessages);
    setInput("");
  };

  return (
    <>
      <div
        className="fixed bottom-5 right-5 w-14 z-[9999] h-14 bg-teal-500 text-white rounded-full flex items-center justify-center shadow-lg cursor-pointer hover:bg-teal-600 transition"
        onClick={toggleChat}
      >
        <MessageCircle className="w-7 h-7" />
      </div>

      {/* Chat Box */}
      {open && (
        <div className="fixed bottom-20 right-5 w-80 z-[9999] min-h-[400px] max-h-[400px] bg-white border border-gray-300 rounded-2xl flex flex-col shadow-2xl overflow-hidden">
          {/* Header */}
          <div className="bg-teal-500 text-white p-3 font-semibold">
            Chat with us
          </div>

          {/* Messages */}
          <div className="flex-1 p-3 overflow-y-auto space-y-2 text-sm">
            {messages.map((msg, i) => (
              <div
                key={i}
                className={`px-3 py-2 rounded-lg max-w-[75%] ${
                  msg.sender === "user"
                    ? "bg-teal-500 text-white ml-auto"
                    : "bg-gray-200 text-gray-800 mr-auto"
                }`}
              >
                {msg.text}
              </div>
            ))}
          </div>

          {/* Input */}
          <div className="flex border-t border-gray-200">
            <input
              type="text"
              className="flex-1 px-3 py-2 text-sm outline-none"
              placeholder="Type a message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
            />
            <button
              className="bg-teal-500 text-white px-4 hover:bg-teal-600 transition"
              onClick={sendMessage}
            >
              Send
            </button>
          </div>
        </div>
      )}
    </>
  );
}
